import "./style.scss";
import { FC, useState } from "react";
import { ISideBarListItemObj, ISideBarList } from "@/src/types/sideBar";
import { Link } from "react-router-dom";
import { sideBarMenuSvg } from "@/src/constants/sidebar";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/src/store";
import { reorderSidebarItems } from "@/src/store/slices/SideBarMenu/SideBarMenuSlice";
import { SidebarSvgExportConst } from "@/src/svg/sidebar/SidebarSvgExport";
import ArrowFilter from "@/src/svg/applicationsPage/ArrowFilter";

interface ISidebarNavProps {
  title: string;
  customization: boolean;
  sideBarMenuAllOptions: ISideBarListItemObj[];
  section: keyof ISideBarList;
}

const SidebarNav: FC<ISidebarNavProps> = ({ title, customization, sideBarMenuAllOptions, section }) => {
  const [isMenuHidden, setIsMenuHidden] = useState<boolean>(false);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);
  const dispatch = useDispatch<AppDispatch>();

  const handleEventTitle = () => {
    setIsMenuHidden(!isMenuHidden);
  };

  const handleDragStart = (e: React.DragEvent, index: number) => {
    if (!customization) {
      e.preventDefault();
      return;
    }
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", index.toString());
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = "0.5";
    }
  };

  const handleDragEnd = (e: React.DragEvent) => {
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = "1";
    }
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const handleDragOver = (e: React.DragEvent<HTMLLIElement>, index: number) => {
    if (!customization || draggedIndex === null || draggedIndex === index) return;
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "move";

    if (dragOverIndex !== index) {
      setDragOverIndex(index);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLLIElement>, dropIndex: number) => {
    if (!customization || draggedIndex === null || draggedIndex === dropIndex) return;
    e.preventDefault();
    e.stopPropagation();

    dispatch(
      reorderSidebarItems({
        section,
        dragIndex: draggedIndex,
        hoverIndex: dropIndex,
      })
    );

    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLLIElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;

    if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
      setDragOverIndex(null);
    }
  };

  return (
    <div className="sidebar-nav">
      <div className={`sidebar-nav-title ${isMenuHidden ? "hide" : ""}`} onClick={handleEventTitle}>
        <p>{title}</p>
        <ArrowFilter />
      </div>
      <ul className={`sidebar-nav-ul ${isMenuHidden ? "hide" : ""}`}>
        {sideBarMenuAllOptions &&
          sideBarMenuAllOptions.map((item, index) => (
            <li
              className={`sidebar-nav-ul-li ${draggedIndex === index ? "dragging" : ""} ${dragOverIndex === index ? "drag-over" : ""}`}
              key={item.id}
              draggable={customization}
              onDragStart={(e) => handleDragStart(e, index)}
              onDragEnd={handleDragEnd}
              onDragOver={(e) => handleDragOver(e, index)}
              onDrop={(e) => handleDrop(e, index)}
              onDragLeave={handleDragLeave}
            >
              {customization && (
                <div
                  className="sidebar-nav-ul-li-sign"
                  draggable={false}
                  onMouseDown={(e) => {
                    e.preventDefault();
                  }}
                >
                  <SidebarSvgExportConst.CustomizationLinesSvg />
                </div>
              )}
              {customization ? (
                <div className="sidebar-nav-ul-li-link">
                  {sideBarMenuSvg
                    .filter((itemSvg) => itemSvg.id === item.id)
                    .map((itemSvg) => (
                      <itemSvg.svg key={itemSvg.id} />
                    ))}
                  <p>{item.text}</p>
                </div>
              ) : (
                <Link to={item.link}>
                  {sideBarMenuSvg
                    .filter((itemSvg) => itemSvg.id === item.id)
                    .map((itemSvg) => (
                      <itemSvg.svg key={itemSvg.id} />
                    ))}
                  <p>{item.text}</p>
                </Link>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};
export default SidebarNav;
